export default __webpack_public_path__ + "static/media/man1.27819780.png";